module.exports = "<h3 id=\"terimler\">Terimler</h3>\n<p><a href=\"index.md\">İndexe Geri Git</a></p>\n";